import { Action, Reducer } from 'redux';
import { BrandState, BrandTypes, BrandActionTypes } from './brandTypes';

export const INITIAL_STATE: BrandState = {
  brand: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const brandReducer: Reducer<BrandState> = (
  state: BrandState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as BrandActionTypes;
  switch (actionTypes.type) {
    case BrandTypes.GET_BRAND:
      return {
        ...state,
        brand: { ...state.brand, isLoading: true }
      };
    case BrandTypes.SAVE_BRAND:
      return {
        ...state,
        brand: {
          ...state.brand,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case BrandTypes.RESET_REDUCER_BRAND:
      return {
        ...state,
        brand: INITIAL_STATE.brand
      };
    default:
      return state;
  }
};

export default brandReducer;

